import locatorMapStyle from '../../json/LocatorCustomStyleMap';
import ApiManager from '../api/crud-manager';
import {
  activateGoogleSearchApi,
  buildCategoryFiltering,
  buildSpotsList,
  calculateDistanceLngLat,
  setLocationContainerData,
  setRouteDirection,
  smoothZoomMap
} from '../utils/locator';

// SETTINGS
const locator = {
  showInfoPanel: false,
  showSpotsList: true,
  showInfoWindow: true,
  activeDirectionsService: true
};

// DIRECTIONS OPTIONS
const polylineOptions = {
  strokeColor: '#004783',
  strokeOpacity: 0,
  fillOpacity: 0,
  icons: [
    {
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        fillOpacity: 1,
        scale: 3
      },
      offset: '0',
      repeat: '10px'
    }
  ]
};

const allMarkers = [];
let directionsService;
let directionsRenderer;
let destinationLat;
let destinationLng;
let map;
let stores;
let startMarker;

class LocatorA {
  constructor(options = {}) {
    this.config = {
      locatorMaps: () => document.querySelectorAll('[data-module="Locator__MapA"]'),
      filterButtons: () =>
        document.querySelectorAll('[data-child-module="Locator__ToggleFilters"]'),
      markerIconHome: '/dist/images/icons/maps-marker-home.svg',
      markerIconLocation: '/dist/images/icons/maps-marker-location.svg',
      markerIconActive: '/dist/images/icons/maps-marker-active.svg',
      setHomeIcon: true,
      siteName: 'Projectname',
      infoWindow: new google.maps.InfoWindow({ content: '', ariaLabel: '' }),
      ...options
    };

    this.apiManager = new ApiManager();
  }

  init() {
    const { locatorMaps, markerIconHome, setHomeIcon, siteName } = this.config;

    this.addEventListeners();

    locatorMaps().forEach(moduleMap => {
      const mapCenterLocation =
        moduleMap.getAttribute('data-map-center') !== ''
          ? moduleMap.getAttribute('data-map-center')
          : '51.477928, -0.001545';
      const mapCenterLatitude = Number(mapCenterLocation.split(',')[0]); // 52.211157;
      const mapCenterLongitude = Number(mapCenterLocation.split(',')[1]); // 5.9699231;
      const headquarterLocation =
        moduleMap.getAttribute('data-headquarter') !== ''
          ? moduleMap.getAttribute('data-headquarter')
          : '0.0 0.0';
      destinationLat = Number(headquarterLocation.split(',')[0]);
      destinationLng = Number(headquarterLocation.split(',')[1]);

      locator.showInfoPanel = moduleMap.getAttribute('data-showInfoPanel') === 'true';
      if (locator.showInfoPanel) {
        locator.showInfoWindow = false;
      }

      const mapOptions = {
        center: { lat: mapCenterLatitude, lng: mapCenterLongitude },
        zoom:
          moduleMap.getAttribute('data-zoom-level') !== ''
            ? Number(moduleMap.getAttribute('data-zoom-level'))
            : 8,
        maxZoom: 18,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        fullscreenControl: false,
        styles: locatorMapStyle
      };

      if (typeof google === 'object' && typeof google.maps === 'object') {
        map = new google.maps.Map(moduleMap, mapOptions);

        directionsRenderer = new google.maps.DirectionsRenderer({
          polylineOptions,
          suppressMarkers: true,
          map
        });

        this.setLocationsData();

        if (setHomeIcon && locator.activeDirectionsService) {
          const startLatLng = new google.maps.LatLng(destinationLat, destinationLng);
          startMarker = new google.maps.Marker({
            position: startLatLng,
            map,
            title: siteName,
            zIndex: 9,
            icon: markerIconHome
          });
          startMarker.setPosition(startLatLng);

          if (locator.activeDirectionsService) {
            directionsService = new google.maps.DirectionsService();
          }
        } else {
          const travelmodes = document.querySelectorAll('[data-module="LocatorGmapsTravel"]');
          travelmodes.forEach(travelmode => {
            travelmode.style.display = 'none';
          });
        }

        // Do not remove
        // google.maps.event.addListener(map, 'click', LocatorA.goToClosestMarker);
        google.maps.event.addListener(map, 'click', () => {
          if (locator.showInfoWindow) {
            this.config.infoWindow.close();
          }
        });
      }
    });
  }

  addEventListeners() {
    const buttons = this.config.filterButtons();

    const toggleSpotsCategories = () => {
      const categoriesContainers = document.querySelectorAll(
        '[data-child-module="Locator__ToggleView"]'
      );
      categoriesContainers.forEach(categoriesContainer => {
        if (categoriesContainer.style.display === 'none') {
          categoriesContainer.removeAttribute('style');
        } else {
          categoriesContainer.style.display = 'none';
        }
      });
    };

    if (buttons) {
      buttons.forEach(el => {
        el.addEventListener('click', toggleSpotsCategories);
      });
    }
  }

  addMarkers(data) {
    const { markerIconLocation, markerIconActive } = this.config;

    if (!data) {
      return;
    }

    data.features.forEach(feature => {
      feature.properties.forEach((item, i) => {
        if (item.Latitude != null || item.Longitude != null) {
          const lng = Number(item.Longitude.replace(',', '.')) || null;
          const lat = Number(item.Latitude.replace(',', '.')) || null;
          const markerExists = allMarkers.some(m => m.id === item.Id);
          item.Categories = item.Categories.map(c => c.trim());

          // Same as in Locator-B
          if (!markerExists) {
            const marker = new google.maps.Marker({
              position: { lat, lng },
              map,
              title: item.CompanyName,
              id: item.Id,
              icon: markerIconLocation,
              category: item.Categories,
              lat,
              lng
            });

            marker.addListener('click', () => {
              if (locator.showInfoPanel) {
                setLocationContainerData(
                  item,
                  locator.showInfoPanel,
                  locator.showInfoWindow,
                  marker
                );
              }

              if (locator.showInfoWindow) {
                this.openInfoWindow(marker, item);
              }

              for (let j = 0; j < allMarkers.length; j += 1) {
                allMarkers[j].setIcon(markerIconLocation);
              }
              marker.setIcon(markerIconActive);

              const clickedMarkerLocation = { lat, lng };
              map.panTo(clickedMarkerLocation);

              if (locator.activeDirectionsService) {
                directionsRenderer.setDirections({ routes: [] });

                const contentDistances = blockNone =>
                  document.querySelectorAll('[data-module="TotalTimeDistance"]').forEach(totals => {
                    totals.style.display = blockNone;
                  });

                // Travelmode change for InfoPanel
                const travelmodeItems = document.querySelectorAll(
                  '[data-child-module="LocatorGmapsTravel__Item"]'
                );

                travelmodeItems.forEach(travelmodeItem => {
                  travelmodeItem.classList.remove('is-active');
                  contentDistances('none');
                  travelmodeItem.dataset.lat = lat;
                  travelmodeItem.dataset.lng = lng;
                  if (travelmodeItem.dataset.initialized === 'true') {
                    return;
                  }
                  travelmodeItem.dataset.initialized = 'true';

                  travelmodeItem.addEventListener('click', () => {
                    travelmodeItems.forEach(others => {
                      others.classList.remove('is-active');
                    });
                    contentDistances('block');
                    travelmodeItem.classList.add('is-active');
                    setRouteDirection(
                      Number(travelmodeItem.dataset.lat),
                      Number(travelmodeItem.dataset.lng),
                      travelmodeItem.value,
                      destinationLat,
                      destinationLng,
                      directionsService,
                      directionsRenderer
                    );
                  });
                });
              }

              smoothZoomMap(map, map.getZoom(), 12);
            });

            allMarkers.push(marker);
          } else {
            const markerIndex = allMarkers.findIndex(m => m.id === item.Id);
            allMarkers[markerIndex].category = [
              ...item.Categories,
              ...allMarkers[markerIndex].category
            ].filter((cat, index, self) => self.indexOf(cat) === index);
          }
        } else {
          delete item[i];
        }
      });
    });
  }

  openInfoWindow(markerData, data) {
    this.config.infoWindow.close();
    this.config.infoWindow.setContent(
      setLocationContainerData(data, locator.showInfoPanel, locator.showInfoWindow)
    );
    this.config.infoWindow.open({ map: markerData.getMap(), anchor: markerData });

    google.maps.event.addListener(this.config.infoWindow, 'closeclick', () => {
      const markerIconLocation = '/dist/images/icons/maps-marker-location.svg';
      markerData.setIcon(markerIconLocation);
    });
  }

  setLocationsData() {
    const { lang } = document.documentElement;

    this.apiManager
      .get('/api/v1/storelocater/getalllocations')
      .then(data => {
        // let containsNumberSign = false;
        // data.forEach(d => {
        // containsNumberSign = String(d.Categories).includes('1#');
        const spotsByCulture = data.filter(
          x => x.Culture != null && x.Culture.toLowerCase() === lang.toLowerCase()
        );

        // if (!containsNumberSign) {
        stores = spotsByCulture.reduce((newArr, item) => {
          item.Categories.forEach(c => {
            // if (!String(c).includes('#')) {
            const category = c.trim();
            const catIndex = newArr.findIndex(x => x.categoryId === category);

            if (catIndex === -1) {
              newArr.push({ categoryId: category, category, properties: [item] });
            } else {
              newArr[catIndex].properties.push(item);
            }
            // }
          });
          return newArr;
        }, []);
        // }
        // });

        const locations = {
          type: 'FeatureCollection',
          features: stores
        };

        locations.features.forEach(feature => {
          feature.properties.forEach((property, index) => {
            if (property.Latitude != null || property.Longitude != null) {
              const itemLat = Number(property.Latitude.replace(',', '.'));
              const itemLon = Number(property.Longitude.replace(',', '.'));
              const destLat = Number(destinationLat);
              const destLng = Number(destinationLng);

              const distanceValue = calculateDistanceLngLat(itemLat, itemLon, destLat, destLng)
                .toFixed(1)
                .replace('.', ',');

              property.Distance = distanceValue;
            } else {
              delete property[index];
            }
          });
        });

        this.addMarkers(locations);
        buildCategoryFiltering(locations, allMarkers, destinationLat, destinationLng, true);

        if (locator.showSpotsList) {
          buildSpotsList(locations, false, false, allMarkers, destinationLat, destinationLng);
          activateGoogleSearchApi(map, locations, allMarkers, LocatorA.setCenterLngLat, {
            destinationLat,
            destinationLng
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  // Same function as in locator-B
  static goToClosestMarker(e) {
    const tempAllMarkers = [...allMarkers].filter(marker =>
      map.getBounds().contains(marker.getPosition())
    );

    if (tempAllMarkers.length !== 0) {
      // get the closest marker to the click event
      const distances = [];
      let closest = -1;
      for (let i = 0; i < tempAllMarkers.length; i += 1) {
        const d = google.maps.geometry.spherical.computeDistanceBetween(
          tempAllMarkers[i].position,
          e.latLng
        );
        distances[i] = d;
        if (closest === -1 || d < distances[closest]) {
          closest = i;
        }
      }
      map.panTo(tempAllMarkers[closest].getPosition());
      google.maps.event.trigger(tempAllMarkers[closest], 'click');
    }
  }

  static setCenterLngLat(newLong, newLat) {
    destinationLat = newLat;
    destinationLng = newLong;
  }
}

export default LocatorA;
